import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

import { getFilterOptionsService } from '../../services/get-filters.service';
import {
  FilterOptionSelectedValue,
  FilterSelectedValue,
} from './interfaces/filter-selected-value.interface';
import { FilterOptions } from './interfaces/filter.interface';

export interface AppFilterOptions {
  options: FilterOptionSelectedValue[];
  isFetching: boolean;
}
export const ASYNC_FILTERS_OPTIONS = 'asynx-filter-options/REACT_QUERY_KEY';

const defaultFilterOptions: FilterOptions = {
  id: '',
  options: [],
};
export const useAppAsyncFilterOptions = (
  id: string,
  filterSelection?: FilterSelectedValue[],
  search?: string | undefined | null,
) => {
  const enabled = useMemo(() => {
    return search !== undefined;
  }, [search]);

  //const [enabled, setEnabled] = useState(search === undefined)
  const filterSel: FilterSelectedValue[] = useMemo(() => {
    if (filterSelection) {
      return filterSelection?.filter((i) => i.id !== id);
    } else {
      return [];
    }
  }, [filterSelection, id]);
  const { data = defaultFilterOptions, isFetching } = useQuery({
    queryKey: [ASYNC_FILTERS_OPTIONS, id, filterSel, search],
    queryFn: () => getFilterOptionsService(id, filterSel, search),
    placeholderData: keepPreviousData,
    enabled,
  });
  // useEffect(() => {
  //     if (isFetching === false) {
  //         setEnabled(false)
  //     }
  // }, [isFetching])
  const value = useMemo(
    (): AppFilterOptions => ({
      options: data?.options,
      isFetching,
    }),
    [data, isFetching],
  );
  return value;
};
